var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.5C15.4618 2.50745 17.8348 3.42045 19.6667 5.065V2.5H21.3333V6.78583C21.3329 7.19612 21.1697 7.58948 20.8796 7.87959C20.5895 8.16971 20.1961 8.33289 19.7858 8.33333H15.5V6.66667H18.9342C17.5798 5.29464 15.791 4.4355 13.8734 4.23602C11.9559 4.03655 10.0286 4.50913 8.42078 5.57301C6.813 6.6369 5.62454 8.22606 5.05846 10.069C4.49238 11.9119 4.58381 13.8942 5.31712 15.6772C6.05044 17.4602 7.38014 18.9332 9.07902 19.8446C10.7779 20.756 12.7405 21.0491 14.6316 20.674C16.5227 20.2988 18.2248 19.2787 19.4471 17.7878C20.6694 16.297 21.3362 14.4279 21.3333 12.5H23C23 14.4778 22.4135 16.4112 21.3147 18.0557C20.2159 19.7002 18.6541 20.9819 16.8268 21.7388C14.9996 22.4957 12.9889 22.6937 11.0491 22.3078C9.10929 21.922 7.32746 20.9696 5.92894 19.5711C4.53041 18.1725 3.578 16.3907 3.19215 14.4509C2.8063 12.5111 3.00433 10.5004 3.76121 8.67316C4.51809 6.8459 5.79981 5.28412 7.4443 4.1853C9.08879 3.08649 11.0222 2.5 13 2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.167 8.33334V12.845L14.9112 15.5892L16.0895 14.4108L13.8337 12.155V8.33334H12.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.50ab672aa78ceabb73106c5aa8301ac3.svg";
export { ForwardRef as ReactComponent };